import React, { useState } from 'react'
import {
  Edit,
  required,
  SimpleForm,
  TextInput,
  useEditController,
  useNotify,
  useRedirect,
  useTranslate
} from 'react-admin'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { Grid } from '@mui/material'
import { NumberInput } from 'src/components/uiElements/fields/NumberInput'
import { AutocompleteInput } from 'src/components/uiElements/fields/AutocompleteInput'
import { dueDateServices } from 'src/services/reservation/due-date/dueDate.service'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'

export const DueDateMethodEdit = (props, { id }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [loadingDueDateRange, setLoadingDueDateRange] = useState(false)
  const [dueDateRange, setDueDateRange] = useState([])
  const { record } = useEditController({ resource: 'due-date-method', id })
  const typeDeterminationOptions = [
    {id:'autocancel_date', label:translate('ra.field.autocancel_date')},
    {id:'date_in', label:translate('ra.field.date_origin_service')},
    {id:'date_out', label:translate('ra.field.date_destination_service')},
    {id:'issuance_datetime', label:translate('ra.field.date_emision')},
    {id:'created_at', label:translate('ra.field.created_at')},
    {id:'cancel_info', label:translate('ra.field.supplier_expense_date')}
  ]


  const onSuccess = () => {
    notify('ra.notification.updated_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.due-date-method') }
    })
    redirect('/due-date-method')
  }

  const onError = () => {
    notify('ra.notification.updated_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.due-date-method') },
    })
  }

   const getDueDateRange = async (name, minLength = 1) => {
     if (name?.length < minLength) {
       setDueDateRange([])
       return
     }
     try {
       setLoadingDueDateRange(true)
       const dueDateRange = await dueDateServices.getByAllDueDateRange({ name__ilike: name })
       setDueDateRange(dueDateRange)
     } catch (error) {
       setDueDateRange([])
     } finally {
       setLoadingDueDateRange(false)
     }
   }

  const transform = (data) => {
    let obj = {
      ...data,
      due_date_range_id: data?.due_date_range_id?.id,
    }

   return obj
  }

  return (
    <Edit
      {...props}
      mutationMode='pessimistic'
      mutationOptions={{ onSuccess, onError }}
      actions={null}
      transform={transform}
    >
      <CardCommon title={translate('ra.title.update_due_date_method')}>
        <SimpleForm
          toolbar={
            <CardCrudBottomButtons
              btnSave={true}
              btnDelete={true}
              fieldsName={['short_name']}
              genderElement='masculine'
            />
          }
        >
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.name')} required>
              <TextInput source='name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.days')}>
              <NumberInput source='days' label='' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.due-date-range')}>
              <AutocompleteInput
                source='due_date_range_id'
                options={dueDateRange}
                loading={loadingDueDateRange}
                optionsText={['name']}
                onSearch={getDueDateRange}
                resetOnLoad={false}
                defaultValue={
                  record?.due_date_range_id
                    ? { ...record?.due_date_range, due_date_range_id: record?.due_date_range?.id }
                    : null
                }
              />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.type_determination_date')}>
              <SelectInput
                size='small'
                optionsText={['label']}
                source='type_determination_date'
                options={typeDeterminationOptions}
                fullWidth
                label=''
                validate={[required()]}
              />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Edit>
  )
}